<div class="item-grid-container">
  <mat-card class="px-2 py-4  shadow">
    <h4 class="new-product-blk-title" translate>pages.newRetailer.productInformation</h4>

    <div class="new-product-form-container">
      <form (ngSubmit)="onNewProductSubmit()" [formGroup]="newProductForm">
        <div class="form-inner  content-details-blk">
          <div class="row my-2">
            <div class="col-12 col-xs-12 col-sm-6">
              <div class="row my-2">
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                  <h4 class="form-item-label mt-4" translate>
                    pages.newRetailer.provider<span class="required">*</span>
                  </h4>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                  <div class="form-item-input">
                    <mat-form-field appearance="outline">
                      <mat-select formControlName="providerName">
                        <mat-option
                          *ngFor="let provider of providers"
                          [value]="provider.providerId"
                        >
                          {{ provider.providerName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
                  <h4 class="form-item-label" translate>
                    pages.newRetailer.productName<span class="required">*</span>
                  </h4>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                  <div class="form-item-input">
                    <mat-form-field class="" appearance="outline">
                      <input
                        matInput
                        required
                        type="text"
                        placeholder="{{'pages.Addproducts.Enterproductname' | translate }}"
                        formControlName="productName"
                      />
                    </mat-form-field>
                    <div *ngIf="f.productName.touched && f.productName.invalid">
                      <div *ngIf="f.productName.errors.required">
                        <mat-hint class="text-danger ms-2">
                          {{'pages.placeholders.ProductNameIsRequired' | translate }}</mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div> 
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
              <h4 class="form-item-label mt-3" translate>
                pages.newRetailer.productDescription<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <textarea
                    matInput
                    required
                    formControlName="productDescription"
                    placeholder="{{ 'pages.ManageProducts.ProductDescription' | translate}}"
                    class="text-area"
                  >
                  </textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row my-2">

            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.ManageProducts.Productdropdownname<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="" appearance="outline">
                  <input
                    matInput
                    required
                    type="text"
                    placeholder="{{ 'pages.Addproducts.Enterdropdownname' | translate}}"
                    formControlName="productDropdownName"
                  />
                </mat-form-field>
                <div *ngIf="f.productDropdownName.touched && f.productDropdownName.invalid">
                  <div *ngIf="f.productDropdownName.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{'pages.placeholders.DropdownNameIsRequired' | translate }}</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>

            
            
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.widelyUsed<span class="required">*</span></h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select formControlName="widelyUsed" required>
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.productType<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select
                    formControlName="productType"
                    (selectionChange)="onproductChange($event)"
                    required
                  >
                    <mat-option
                      *ngFor="let productType of producttypes"
                      [value]="productType"
                    >
                      {{ productType }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.productService<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select formControlName="productService" required>
                    <mat-option
                      *ngFor="let productService of providerService"
                      [value]="productService"
                    >
                      {{ productService }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.responseType<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select formControlName="responseType" required>
                    <mat-option
                      *ngFor="let responseType of responseTypes"
                      [value]="responseType"
                    >
                      {{ responseType }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <div *ngIf="f.responseType.touched && f.responseType.invalid">
                  <div *ngIf="f.responseType.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{'pages.placeholders.ResponseTypeIsRequired' | translate }}</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.serviceCountry<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select formControlName="serviceCountry" required>
                    <mat-option
                      *ngFor="let country of serviceCountries"
                      [value]="country.countryName"
                    >
                      {{ country.countryName }} - {{country.countryPhoneCode}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                SKU<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    type="text"
                    [textMask]="{ mask: numMask, guide: false }"
                    formControlName="sku"
                    minlength="2"
                    maxlength="6"
                  />
                </mat-form-field> 
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.transactionType<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select formControlName="transactionType">
                    <mat-option
                      *ngFor="let transactionType of transactionTypes"
                      [value]="transactionType"
                    >
                      {{ transactionType }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- CellPay Sku fields -->
           
           <div class="row my-2">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                cellPay SKU<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    type="text"
                    [textMask]="{ mask: numMask, guide: false }"
                    formControlName="cellPaySKU"
                    minlength="2"
                    maxlength="6"
                  />
                </mat-form-field> 
              </div>
            </div>
             <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.cellPayCarrierId<span class="required">*</span>
              </h4>
            </div>
               <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    type="text"
                    [textMask]="{ mask: numMask, guide: false }"
                    formControlName="cellPayCarrierId"
                    minlength="2"
                    maxlength="6"
                  />
                </mat-form-field> 
              </div>
            </div>
          </div>

          

          <div class="row my-2">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.exchangeRate<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="" appearance="outline">
                  <input
                    matInput
                    type="text"
                    required
                    placeholder="Enter Exchange Rate"
                    formControlName="exchangeRate"
                  />
                </mat-form-field>
                <div *ngIf="f.exchangeRate.touched && f.exchangeRate.invalid">
                  <div *ngIf="f.exchangeRate.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{'pages.placeholders.ExchangeRateIsRequired' | translate }}</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.codeGroup<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select formControlName="codeGroup" required>
                    <mat-option *ngFor="let item of codeGroups" [value]="item">
                      {{ item }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.planType<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select formControlName="planType">
                    <mat-option *ngFor="let item of plantypes" [value]="item">
                      {{ item }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.currency<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select formControlName="currency" required>
                    <mat-option value="USD">USD</mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="f.currency.touched && f.currency.invalid">
                  <div *ngIf="f.currency.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{'pages.placeholders.CurrencyIsRequired' | translate }}</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.carrier<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select formControlName="carrier" required>
                    <mat-option
                      *ngFor="let carrierType of carrierTypes"
                      [value]="carrierType.carrierName"
                    >
                      {{ carrierType.carrierName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.purchaseDiscount<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="row g-0">
                <div class="col-3">
                  <div class="form-item-input">
                    <mat-form-field class="w-100 mat-field-split-left" appearance="outline">
                      <mat-select
                        formControlName="purchaseDiscountType"
                        [(ngModel)]="purchaseDiscountTypevalue"
                        required
                      >
                        <mat-option value="$">$</mat-option>
                        <mat-option value="%">%</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-9">
                  <div class="form-item-input">
                    <mat-form-field class="mat-field-split-right" appearance="outline">
                      <input
                        matInput
                        type="number"
                        placeholder="{{'pages.Addproducts.Enterpurchasediscount' | translate }}"
                        formControlName="purchaseDiscount"
                        required
                      />
                    </mat-form-field>
                    <div
                      *ngIf="
                        f.purchaseDiscount.touched && f.purchaseDiscount.invalid
                      "
                    >
                      <div
                        *ngIf="
                          f.purchaseDiscount.touched && f.topupvalueCustomer.errors
                        "
                      >
                        <mat-hint class="text-danger ms-2">
                          Purchase Discount is Required.</mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.faceValueMin<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-3 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="" appearance="outline">
                  <input
                    matInput
                    type="number"
                    placeholder="{{'pages.Addproducts.Enterfacevalueminimum' | translate }}"
                    formControlName="faceValueMinAmt"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.faceValueMax<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-3 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="" appearance="outline">
                  <input
                    matInput
                    type="number"
                    required
                    placeholder="{{'pages.Addproducts.Enterfacevaluemax' | translate }}"
                    formControlName="faceValueMaxAmt"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>


          <div class="row my-2">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.fee<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="" appearance="outline">
                  <input
                    matInput
                    type="number"
                    placeholder="{{'pages.Addproducts.Enterfee' | translate }}"
                    formControlName="fee"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div formArrayName="commissionInfo" class="comissions-blk">
            <ng-container>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"
                  *ngFor="let item of pricelists; let pointIndex = index"
                  [formGroupName]="pointIndex"
                >
                  <div class="row">
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label">
                        {{ item.priceListName }} ({{item.priceListType}})<span class="required">*</span>
                      </h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline">
                          <mat-hint matPrefix class="fw-boold ">{{ purchaseDiscountTypevalue }} &nbsp;</mat-hint>
                          <input
                            matInput
                            type="text"
                            placeholder="Enter {{ item.priceListName }}"
                            [formControlName]="item.priceListName"
                          />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="form-footer">
          <ul class="list-inline text-center">
            <li class="list-inline-item">
              <button
                mat-raised-button
                [disabled]="!newProductForm.valid"
                color="primary"
                type="submit"
                class="rounded-0"
              >
                <span translate class="translate">pages.newRetailer.save</span>
              </button>
            </li>
            <li class="list-inline-item">
              <button
                mat-stroked-button
                color="primary"
                type="button"
                class="rounded-0"
                (click)="onCancel()"
              >
                <span translate class="translate">pages.newRetailer.cancel</span>
              </button>
            </li>
            <li class="list-inline-item"></li>
          </ul>
        </div>
      </form>
    </div>
  </mat-card>
</div>
